module.exports = __webpack_public_path__ + "img/quiz_imagesmall.ace9dc2f.svg";